<section class="grid grid-cols-1 gap-8 lg:grid-cols-[385px_1fr]">
  @if (!loading()) {
    @if (employee(); as emp) {
      <div class="flex flex-col gap-6">
        <app-image-card [image]="emp.image" [priority]="true" sectionClassName="bg-gray-100"
                        imageContainerClassName="-mb-6 pt-4"/>

        @for (skill of emp.skills; track skill) {
          <app-compound-card
            [title]="skill.title"
            [tableGridItems]="skill.tableContent"
            sectionClassName="bg-gray-100"
            titleClassName="text-xl font-medium"/>
        }
      </div>

      <div class="flex flex-col gap-6">
        <app-image-card
          [title]="emp.fullName"
          [subtitle]="emp.positionName"
          [headerBadges]="emp.topBadges"
          [footerBadges]="emp.bottomBadges"
          [highlightTitle]="emp.abstract?.title"
          [description]="emp.abstract?.description"
          titleClassName="text-2xl"
          subtitleClassName="text-xl"
          highlightTitleClassName="text-xl"
          descriptionClassName="text-tertiary-foreground"
          sectionClassName="bg-gray-100"/>

        @for (qualification of emp.qualifications; track qualification) {
          <div class="flex w-full flex-col">
            <div class="flex h-full flex-col items-center gap-2.5 rounded-3xl bg-gray-100 p-6 lg:items-start">
              <span class="text-2xl font-semibold">{{ qualification.title }}</span>
            </div>

            <div class="flex h-full flex-col items-center gap-4 rounded-3xl bg-gray-100 p-6 lg:items-start">
              @for (item of qualification.items; track item) {
                <div class="flex w-full flex-col gap-2">
                  <span class="text-xl font-medium">{{ item.title }}</span>
                  <p class="text-tertiary-foreground">{{ item.description }}</p>
                </div>
              }

              @if (qualification.showButton) {
                <div class="w-full">
                  <button hlmBtn variant="contrast">View Certificate</button>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  } @else {
    <div class="flex flex-col gap-6">
      <hlm-skeleton class="e-full h-[200px]"/>
      @for (mock of [1, 2]; track mock) {
        <hlm-skeleton class="e-full h-[300px]"/>
      }
    </div>

    <div class="flex flex-col gap-6">
      @for (mock of [1, 2, 3]; track mock) {
        <hlm-skeleton class="e-full h-[500px]"/>
      }
    </div>
  }
</section>
